export function generatePublicUrl (url: string) {
    return process.env.REACT_APP_BACKEND_URL + url
}